import React from 'react'
import { Fade } from 'react-awesome-reveal'
import { services } from '../../utility/sarvices'

function Services() {

  const handleSubmit = (e) => {
    e.preventDefault()
  }
  return (
    <section className="section-services padding-tb-100 bg-market">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <Fade triggerOnce direction='up' duration={1500} className="banner justify-content-center">
              <h2>AI Turn Information Into Actionable Insights</h2>
            </Fade>
          </div>
        </div>
        <div className="row mb-m-24">

          {
            services.map((data, index) => (
              <div key={index} className="col-xl-3 col-lg-6 col-md-6 col-sm-12 zx-serch-main">
                <Fade triggerOnce duration={500} direction='up'>
                  <div className="zx-service">
                    <img src={data.image} alt="maeketing" />
                    <div className="zx-market">
                      <h4>{data.title}</h4>
                      <p>
                        Lorem ipsum felis consur adipiscing elit. Nunc condimentum felis tellus pretium
                        voluptatum.
                      </p>
                    </div>
                    <div className="active-read">
                      <a onClick={handleSubmit} href="/">Read more</a>
                      <i className="fa-solid fa-arrow-right-long"></i>
                    </div>
                  </div>
                </Fade>
              </div>

            ))
          }

        </div>
      </div>
    </section>
  )
}

export default Services
